/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type PromoteRequestBody = {
  /**
   * The bypass request to promote.
   */
  riskPolicyBypassRequestId: string;
};

/** @internal */
export type PromoteRequestBody$Outbound = {
  risk_policy_bypass_request_id: string;
};

/** @internal */
export const PromoteRequestBody$outboundSchema: z.ZodMiniType<
  PromoteRequestBody$Outbound,
  PromoteRequestBody
> = z.pipe(
  z.object({
    riskPolicyBypassRequestId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      riskPolicyBypassRequestId: "risk_policy_bypass_request_id",
    });
  }),
);

export function promoteRequestBodyToJSON(
  promoteRequestBody: PromoteRequestBody,
): string {
  return JSON.stringify(
    PromoteRequestBody$outboundSchema.parse(promoteRequestBody),
  );
}
